import ProxyBase from '../../../../../core/proxies/ProxyBase'

class FinancialStatementProxyClass extends ProxyBase {
  getDataAvailability(params) {
    return this.post('GetDataAvailability', params)
  }
}

export const FinancialStatementProxy = new FinancialStatementProxyClass(
  'FinancialStatement/',
)

class ReportProxy extends ProxyBase {
  getSampleReport(params) {
    return this.get('SampleReport', params, 'download')
  }

  getReportItem(params) {
    return this.get('FiinGateFactsheetReportItem', params)
  }

  getReportSources(params) {
    return this.get('ReportSources', params)
  }

  getFiinGateReportTypes(params) {
    return this.get('FiinGateReportTypes', params)
  }
}

export default new ReportProxy('Report/')
